<span class="filing-editor-sub-tab">
  <button class="link-button transparent">
    <a [ngClass]="{ active: tab.isActive }" (click)="onTabClicked()">
      <span>{{ tab.caption }}</span>
      <fsx-tab-validation [isValid]="tab.isValid"></fsx-tab-validation>
    </a>
  </button>
</span>
